export const securityFileCheck = {
  value: {
    props: {},
  },
}
